/**
 * Creates an object composed of the picked object properties.
 * A native JavaScript replacement for lodash.pick
 *
 * @param obj The source object
 * @param keys An array of property names to pick
 * @returns A new object containing only the specified properties
 */
export function pick<T extends object, K extends keyof T>(
  obj: T,
  keys: readonly K[]
): Pick<T, K> {
  const result = Object.create(null);

  for (const key of keys) {
    result[key] = obj[key] ?? undefined;
  }

  return result;
}
